import { RegtankOnboardingStatusEnum } from "../constant/enum";

const isFinalOnboardingLink = (
  onboardingStatus: RegtankOnboardingStatusEnum
) => {
  if (
    onboardingStatus !== RegtankOnboardingStatusEnum.APPROVED &&
    onboardingStatus !== RegtankOnboardingStatusEnum.REJECTED &&
    onboardingStatus !== RegtankOnboardingStatusEnum.EXPIRED
  ) {
    return false;
  }
  return true;
};

export const checkIsExpired = (expiredDate: string) => {
  const parsedExpiredDate = expiredDate.replace(" ", "T") + "Z";
  return parsedExpiredDate <= new Date().toISOString();
};

export const checkOnboardingLinkValid = (
  noOfAttemptsLiveness: number,
  onboardingStatus: RegtankOnboardingStatusEnum,
  expiredDate: string
) => {
  if (!isFinalOnboardingLink(onboardingStatus) && !checkIsExpired(expiredDate))
    return true;
  return false;
};

export const getLatestRegtankOnboardingDetail = (regtankRequest: any) => {
  if (regtankRequest && regtankRequest.length > 0) {
    return regtankRequest?.[0];
  }
};
